export default {
  dataBrowser: { id: 'data_browser' },
  dataToShow: { id: 'data_to_show' },
  prodAnHealth: { id: 'prod_and_health' },
  environmentData: { id: 'environment_data' },
  logbookData: { id: 'logbook_data' },
  dateRange: { id: 'date_range' },
  siteList: { id: 'sites' },
  unitGroupList: { id: 'unit_groups' },
  units: { id: 'units' },
  allGroups: { id: 'all_groups' },
  locusList: { id: 'locus_list' },
  allLocuses: { id: 'all_locuses' },
  unselectAll: { id: 'unselect_all' },
  fishCount: { id: 'product_and_health_fish_count_type' },
  averageWeight: { id: 'product_and_health_average_weight_type' },
  biomass: { id: 'product_and_health_biomass_type' },
  mortality: { id: 'product_and_health_mortality_type' },
  mortalityCount: { id: 'product_and_health_mortality_count_type' },
  combineCharts: { id: 'combine_charts' },
  exportToCsv: { id: 'export_to_csv' },
}
